module.exports = "/_next/static/images/SBLogo-175f164ecf9d2820dea656ef4134a574.png";